/**
 * 📋 AdminPageHeader - Componente de Cabeçalho Padrão para Páginas Admin
 * 
 * Componente padronizado para títulos de páginas administrativas
 * com ícone, título e subtítulo opcional
 */

import React from 'react';
import { Icon } from '@iconify/react';
import './AdminPageHeader.scss';

const AdminPageHeader = ({ icon, title, subtitle }) => {
  return (
    <div className="admin-page-header">
      <div className="admin-page-header__title-wrapper">
        {icon && (
          <Icon icon={icon} className="admin-page-header__icon" />
        )}
        <span className="admin-page-header__title">{title}</span>
      </div>
      {subtitle && (
        <span className="admin-page-header__subtitle">{subtitle}</span>
      )}
    </div>
  );
};

export default AdminPageHeader;

